import moment, { MomentInput, DurationInputArg1 } from 'moment';

const setStartEndOfDay = <T>(
  object: T,
  keys: [keyof T, keyof T] | [keyof T, keyof T, keyof T, keyof T]
): T => {
  const result = { ...object };
  const [start, end, timeStart, timeEnd] = keys;

  if ((result[start] && !timeStart) || (result[start] && timeStart && !result[timeStart])) {
    result[start] = moment(result[start] as unknown as MomentInput)
      .startOf('day')
      .format() as any;
  }

  if ((result[end] && !timeEnd) || (result[end] && timeEnd && !result[timeEnd])) {
    result[end] = moment(result[end] as unknown as MomentInput)
      .endOf('day')
      .format() as any;
  }

  if (result[start] && timeStart && result[timeStart]) {
    result[start] = moment(result[start] as unknown as MomentInput)
      .add(moment.duration(result[timeStart] as unknown as DurationInputArg1))
      .format() as any;
  }

  if (result[end] && timeEnd && result[timeEnd]) {
    result[end] = moment(result[end] as unknown as MomentInput)
      .add(moment.duration(result[timeEnd] as unknown as DurationInputArg1))
      .format() as any;
  }

  return result;
};

export default setStartEndOfDay;
